const CustomDot = ({ urls, onClick, ...rest }: any) => {
  const { index, active } = rest;

  return (
    <button
      className={`border-2 ${active ? 'border-blue-500' : 'border-transparent'} p-1 rounded-md`}
      onClick={() => onClick()}
    >
      <img
        src={urls[index]}
        alt={`Thumbnail ${index}`}
        className="w-16 h-16 object-contain rounded-md"
      />
    </button>
  );
};

export default CustomDot;
